
import {
  CardContent,
  Card,
  Grid,
  Alert,
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import { getPublicImagePath } from "../App";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    image: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    primary: {
      marginTop: '2px',
      alignItems: 'center',
      justifyContent: 'center',
      top: `50%`,
      left: `50%`,
    },
    overlay: {
      marginTop: '70px',
    },
  })
);

export default function RestrictedPage() {
  const classes = useStyles();

  return (
    <div className={classes.overlay}>
      <ResponsiveDrawer title="Restricted Page">
        <Grid container spacing={1} className={classes.primary}>
          <Grid item>
            <Card className={classes.primary}>
              <CardContent>
                <Alert severity="error">
                  <AlertTitle>Restricted Access</AlertTitle>
                  Sorry, you do not have the access to view this page.
                </Alert>
                <img className={classes.image} src={getPublicImagePath(`/VendDisabled.png`)} alt={"Restricted Page"}></img>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </ResponsiveDrawer>
    </div>
  );

}
